import React from 'react'

import Swemmingpol from "../images/Swimming Pool_Berhampore.jpg";
import vilasclubresort from "../images/Vila's Club Resort View.jpg";
import swemmingpolberhampore from "../images/Swimming pol.jpg";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import vilaslove from "../images/vilas.jpg";
import RECEPTION from "../images/reception.jpg";
import build from "../images/hotel building.jpg";
import RECEPTIONarea from "../images/reception area office.jpg";
import vilasvojan from "../images/vilas vojan.jpg";


function Gallery() {
    return (
        <div>
            <div className='album py-0'>
                <div className='container'>
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1">
                                <Zoom>
                                <img src={vilaslove} className="card-img-top imge2" alt="vilas club resort"/>
                                </Zoom>
                                <div className="overlay1">WE LOVE VILA'S CLUB RESORT </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1">
                          <Zoom>
                                <img src={RECEPTION} className="card-img-top image2" alt="Vila's Club Resort"/>
                                </Zoom>
                               
                                <div className="overlay1">RECEPTION & VOJAN RESTAURANT </div>
                            </div>
                        </div>
                   
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={build} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">VILA'S CLUB RESORT </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={RECEPTIONarea} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">RECEPTION VIEW </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={swemmingpolberhampore} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">SWIMMING POOL DRONE VIEW </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={vilasclubresort} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">SWIMMING POOL DRONE VIEW </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={Swemmingpol} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">SWIMMING POOL DRONE VIEW </div>
                            </div>
                        </div>
                        
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={vilasvojan} className="card-img-top image2" alt="vilasvojan"/>
                                 </Zoom>
                               
                                 <div className="overlay1">SWIMMING POOL DRONE VIEW </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Gallery